import { ActionReducerMap } from "@ngrx/store";
import { carteraReducer, CarteraState} from "./store/reducers/cartera.reducer";
import {  DetallesCarteraReducer ,DetallesCarteraState } from './store/reducers/carteraDetalles.reducer';;
import { MetaReducer } from "@ngrx/store";
import { hydrationMetaReducer } from "./store/reducers/hydrations.reducer";



export interface AppState {
   carteras: CarteraState;
   DetallesCarteras: DetallesCarteraState;

}

export const appReducers: ActionReducerMap<AppState> = {
  carteras: carteraReducer,
  DetallesCarteras: DetallesCarteraReducer,

};

export const metaReducers: MetaReducer[] = [];
